//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const OAuthDatasourceAuth: FeatureFlag = {"Id":"OAuthDatasourceAuth","Label":"[10.20]OAuth datasource auth","Impact":"Enable OAuth client-credentials authentication for external-link datasources.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
